import React from 'react';
import { Link } from 'react-router-dom';
import style from "./style.module.css";
import boundClasses from "classnames/bind";

export interface IChild {
    title: string
    body: string
    imgSrc?: string
    altText?: string
}

export interface IExternalLinkProps {
    url: string;
    cta: string;
    internal?: boolean;
    onNav?: (nav: string) => void;
    solo?: boolean;
}

export function ExternalLink(props: IExternalLinkProps) {
    const onNav = (nav: string) => {
        return (event: React.MouseEvent<HTMLElement>) => {
            if (props.onNav) {
                props.onNav(nav);
            }
        }
    }
    
    const linkClass = boundClasses(
        { [style.link]: true },
        { [style.solo]: props.solo }
    )
    
    return (
        props.internal && props.onNav ?
            <Link
                className={linkClass}
                to={props.url}
                onClick={onNav(props.url)}
            >
                <span className={style.cta}>{props.cta}</span>
                <div className={style.arrow} />
            </Link>
            : <a
                className={linkClass}
                href={props.url}
                target="_blank"
                rel="noreferrer"
            >
                <span className={style.cta}>{props.cta}</span>
                <div className={style.arrow} />
            </a>
    )
}